export const getMultiOrgUserTrackingId = (email: string) => {
  return `multi-organisation-user|${email}`
}
